import './Modal.scss';
import React, { type ReactNode } from 'react';
import classNames from 'classnames';
import CloseButton from '../closeButton/CloseButton';
import ModalActionButtons from '../modalActionButtons/ModalActionButtons';

export type ModalProps = {
    className?: string;
    onClose: (param?: any) => void;
    show: boolean;
    isLoading?: boolean;
    onCancel?: (param?: any) => void;
    onAction?: (param?: any) => void;
    localeAction?: string;
    localeCancel?: string;
    disabled?: boolean;
    position?: 'top' | 'bottom' | 'left' | 'right' | 'center';
    children?: any,
    name?: string;
};

type ModalComponent = React.FC<ModalProps> & {
    Content: React.FC<{ children: ReactNode }>;
    Title: React.FC<{ children: ReactNode }>;
    Header: React.FC<{ children: ReactNode }>;
};

const Content = ({ children }) => (
    <div className="b-modal-window__content">{children}</div>
);
const Title = ({ children }) => (
    <h4 className="b-modal-window__title">{children}</h4>
);
const Header = ({ children }) => (
    <div className="b-modal-window__header">{children}</div>
);

const Modal: ModalComponent = ({
    className,
    show,
    children,
    onClose,
    onCancel,
    onAction,
    isLoading,
    localeAction,
    localeCancel,
    disabled,
    position = 'center',
    name
}) => {
    if (!show) {
        return null;
    }

    return (
        <div 
            className={classNames('b-modal', className, isLoading && "is-loading")}
            data-testid={name}
        >
            <div className={classNames('b-modal-window', position)}>
                <div className="b-modal-window-content">
                    {children}
                    {(onCancel || onAction) && (
                        <ModalActionButtons
                            onAction={onAction}
                            localeAction={localeAction}
                            onCancel={onCancel}
                            localeCancel={localeCancel}
                            disabled={disabled}
                            isLoading={isLoading}
                        />
                    )}
                </div>
                <CloseButton large onClick={onClose} isDisabled={isLoading} />
            </div>
        </div>
    );
};

Modal.Content = Content;
Modal.Title = Title;
Modal.Header = Header;

export default Modal;
